import { AccountMfaView } from '../../components/account-edit-mfa/AccountMfaView';

export const EditMfaView = () => <AccountMfaView />;
